<h1 mat-dialog-title>Add a comment</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
    <mat-dialog-content [formGroup]="dialogForm">
        <mat-form-field>
            <mat-label>Comments</mat-label>
            <textarea matInput formControlName="comment" placeholder="Type your message..."></textarea>
            <!-- Live Character Counter (Appears on the right side) -->
            <mat-hint align="end">{{ dialogForm.get('comment')?.value?.length || 0 }} characters</mat-hint>
            <mat-error *ngIf="dialogForm.get('comment')?.hasError('required')">This field is required.</mat-error>
            <mat-error *ngIf="dialogForm.get('comment')?.hasError('maxlength')">Cannot be more than {{ char_limit }} characters.</mat-error>
            <mat-error *ngIf="dialogForm.get('comment')?.invalid">This comment cannot be empty</mat-error>
        </mat-form-field>
    </mat-dialog-content>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onSubmit()" cdkFocusInitial>Submit</button>
</div>